import { AuthToken } from "./auth";

export type UserMetaData = {
  name: string;
  solana_address: string;
  phone_code: string;
  phone_number: string;
  phone_number_code: string;
  phone_number_verified: string;
  is_provider: string;
  approved_terms_version?: string;
  wallet_type: string;
  wallet_address: string;
  wallet_address_solana?: string;
  wallet_address_aptos?: string;
  wallet_verified: string;
  role: string;
  viewed_welcome_message?: string;
  viewed_io_elements_message?: string;
  picture: string;
  timezone: string;
  solana_wallet_addresses?: UserWalletType[];
  aptos_wallet_addresses?: UserWalletType[];
};

export enum BalanceType {
  CLOUD = "cloud",
  WORKER = "worker",
  BC8 = "bc8",
  IOWORKER = "ioWorker",
  IOCLOUD = "ioCloud",
  CREDITS = "credits_balance",
  CREDITS_WITHDRAWABLE = "credits_withdrawable_balance",
  CREDITS_COURTESY = "credits_courtesy_balance",
  ALL_CREDITS = "all_credits",
  CREDITS_USED = "credits_used"
}

export enum NotificationType {
  SUCCESS = "success",
  CRITICAL = "critical",
  ERROR = "error",
  INFO = "info",
  PROMO = "promo"
}

export type NotificationFilterType = "device" | "cluster" | "all";

export enum CookiePreferenceType {
  FUNCTIONAL = "functional",
  ANALYTICS = "analytics",
  TRACKING = "tracking"
}

export type UserAuthToken = AuthToken & {
  "https://io.net/user": {
    created: boolean;
    io_id: string;
    primary_mail: string;
  };
};

export type UserInfo = {
  blockRewardsSuspicious?: boolean;
  isWorker?: boolean;
  isCloud?: boolean;
};

export type UserWalletType = {
  wallet_address: string;
  is_primary: boolean;
  is_active: boolean;
  wallet_type: "solana" | "aptos";
  created_at: string;
};

export type ManageSubscriptionResponse = {
  status: string;
  data: {
    billing_portal_session_id: string;
    billing_portal_session_url: string;
  };
};

export type SubscriptionStatus = {
  created_at: string;
  customer_id: string;
  id: string;
  latest_invoice_id: string;
  pricing_model: string | "INTELLIGENCE_MONTHLY";
  status: string | "active" | "inactive";
  subscription_id: string;
};

export type SubscriptionStatusResponse = {
  status: string;
  data: {
    daily_limit: number;
    subscription_type: string | "PREMIUM" | "BASIC" | "ENTERPRISE";
    subscription_details: SubscriptionStatus;
  };
};

export type SubscriptionResponse = {
  status: string;
  data: {
    checkout_session_id: string;
    checkout_session_url: string;
  };
};

export type DiscountedPlan = {
  price_model: string;
  amount_off?: number;
  percent_off?: number;
};

export type DiscountValidationResponse = {
  valid: boolean;
  plans: DiscountedPlan[];
};
